<template>
  <div>
    <VerifyIdentitySuccess
      v-if="displaySuccessPage"
      :mfaPreference="mfaPreference"
      class="md:w-480 md:mx-auto"
    />
    <VerifyIdentityError
      v-else-if="displayErrorPage"
      class="md:w-480 md:mx-auto"
      :errorTitle="$t('mfa.modality.locked')"
      :errorBody="$t('mfa.modality.max_attempt_retry_later')"
      :cancelText="$t('common.cancel_btn')"
      @cancel="$emit('cancel')"
    />
    <VerifyMfa
      v-else
      class="md:w-458 md:mx-auto"
      :codeError="displayMfaCodeError"
      :autoSendCode="true"
      :helperText="helperText"
      :displayCheck="displayCheck"
      :displayCodeResend="displayCodeResend"
      :displayCodeSent="displayCodeSent"
      :displayExplanation="displayExplanation"
      @cancel="$emit('cancel')"
      @requestMfaCode="$emit('requestMfaCode')"
      @verifyMfaCode="(totp) => $emit('verifyMfaCode', totp)"
    />
  </div>
</template>

<script>
import VerifyIdentityError from './VerifyIdentityError'
import VerifyIdentitySuccess from './VerifyIdentitySuccess'
import VerifyMfa from './VerifyMfa'

export default {
  components: { VerifyMfa, VerifyIdentitySuccess, VerifyIdentityError },
  props: {
    mfaPreference: {
      type: String,
      required: true,
    },
    helperText: {
      type: String,
      required: true,
    },
    displayCheck: {
      type: String,
      required: true,
    },
    displayExplanation: {
      type: String,
      required: true,
    },
    displayCodeResend: {
      type: Boolean,
      required: true,
    },
    displayCodeSent: {
      type: String,
      required: true,
    },
    displaySuccessPage: {
      type: Boolean,
      default: false,
    },
    displayErrorPage: {
      type: Boolean,
      default: false,
    },
    displayMfaCodeError: {
      type: Boolean,
      required: true,
    },
  },
}
</script>
